module.exports = __webpack_public_path__ + "static/media/detailedCricketWhite.8ffac7af.svg";